import React from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import StyledTooltip from "../tooltips/StyledTooltip";

const ToolbarTextButton = ({id, label, icon, tooltip, onClick, active, disabled}) => (
  <StyledTooltip title={tooltip}>
    <Button
      id={id}
      size="small"
      color={active ? "primary" : "inherit"}
      startIcon={icon}
      onClick={onClick}
      disabled={!!disabled}
      aria-pressed={!!active}
    >
      {label}
    </Button>
  </StyledTooltip>
);

ToolbarTextButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  tooltip: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToolbarTextButton;
